import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ContentsByDueDateQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.PerformancesFilters>;
}>;


export type ContentsByDueDateQuery = { contentPerformances: { pageInfo?: { hasNextPage?: boolean | null } | null, edges?: Array<{ node: { __typename: 'ArticlePerformanceType', id: string, isArchived?: boolean | null, entityId: string, enrolmentInfo?: { dueDate?: string | null } | null, entity?: { id: string, name: string, type: Types.ResourceTypeEnum, status: Types.ResourceStatusEnum, duration: number, cover?: { url?: string | null } | null } | {} | null } | { __typename: 'BasePerformanceSchema' } | { __typename: 'CoursePerformanceType', id: string, isArchived?: boolean | null, entityId: string, enrolmentInfo?: { dueDate?: string | null } | null, entity?: { id: string, name: string, type: Types.ResourceTypeEnum, status: Types.ResourceStatusEnum, duration: number, cover?: { url?: string | null } | null } | {} | null } | { __typename: 'EventPerformanceType', id: string, isArchived?: boolean | null, entityId: string, enrolmentInfo?: { dueDate?: string | null } | null, entity?: { id: string, name: string, type: Types.ResourceTypeEnum, status: Types.ResourceStatusEnum, duration: number, cover?: { url?: string | null } | null } | { id: string, name: string, type: Types.ResourceTypeEnum, status: Types.ResourceStatusEnum, duration: number, cover?: { url?: string | null } | null } | { id: string, name: string, type: Types.ResourceTypeEnum, status: Types.ResourceStatusEnum, duration: number, cover?: { url?: string | null } | null } | { id: string, name: string, type: Types.ResourceTypeEnum, status: Types.ResourceStatusEnum, duration: number, cover?: { url?: string | null } | null } | { id: string, name: string, type: Types.ResourceTypeEnum, status: Types.ResourceStatusEnum, duration: number, cover?: { url?: string | null } | null } | { id: string, name: string, type: Types.ResourceTypeEnum, status: Types.ResourceStatusEnum, duration: number, cover?: { url?: string | null } | null } | {} | null } | { __typename: 'ExercisePerformanceType', id: string, isArchived?: boolean | null, entityId: string, enrolmentInfo?: { dueDate?: string | null } | null, entity?: { id: string, name: string, type: Types.ResourceTypeEnum, status: Types.ResourceStatusEnum, duration: number, cover?: { url?: string | null } | null } | {} | null } | { __typename: 'ExternalContentPerformanceType', id: string, isArchived?: boolean | null, entityId: string, enrolmentInfo?: { dueDate?: string | null } | null, entity?: { id: string, name: string, type: Types.ResourceTypeEnum, status: Types.ResourceStatusEnum, duration: number, cover?: { url?: string | null } | null } | {} | null } | { __typename: 'HomeworkPerformanceType' } | { __typename: 'KnowledgeAssetPerformanceType' } | { __typename: 'MicroLearningPerformanceType' } | { __typename: 'PathPerformanceType', id: string, isArchived?: boolean | null, entityId: string, enrolmentInfo?: { dueDate?: string | null } | null, entity?: { id: string, name: string, type: Types.ResourceTypeEnum, status: Types.ResourceStatusEnum, duration: number, cover?: { url?: string | null } | null } | {} | null } | { __typename: 'QuestionPerformanceType' } | { __typename: 'QuizPerformanceType', id: string, attemptId: string, isArchived?: boolean | null, entityId: string, enrolmentInfo?: { dueDate?: string | null } | null, entity?: { duration: number, id: string, type: Types.ResourceTypeEnum, name: string, status: Types.ResourceStatusEnum, cover?: { url?: string | null } | null } | {} | null } | { __typename: 'RoleplayPerformanceType' } | { __typename: 'ScormPerformanceType', id: string, isArchived?: boolean | null, entityId: string, enrolmentInfo?: { dueDate?: string | null } | null, entity?: { id: string, name: string, type: Types.ResourceTypeEnum, status: Types.ResourceStatusEnum, duration: number, cover?: { url?: string | null } | null } | {} | null } | { __typename: 'SubTaskPerformanceType' } | { __typename: 'SurveyPerformanceType', id: string, isArchived?: boolean | null, entityId: string, enrolmentInfo?: { dueDate?: string | null } | null, entity?: { id: string, name: string, type: Types.ResourceTypeEnum, status: Types.ResourceStatusEnum, duration: number, cover?: { url?: string | null } | null } | {} | null } | { __typename: 'TaskPerformanceType', id: string, isArchived?: boolean | null, entityId: string, enrolmentInfo?: { dueDate?: string | null } | null, entity?: { id: string, name: string, type: Types.ResourceTypeEnum, status: Types.ResourceStatusEnum, duration: number, cover?: { url?: string | null } | null } | {} | null } | { __typename: 'TaskSectionPerformanceType' } }> | null } };


export const ContentsByDueDateDocument = /*#__PURE__*/ gql`
    query contentsByDueDate($filters: PerformancesFilters) {
  contentPerformances(filters: $filters) {
    pageInfo {
      hasNextPage
    }
    edges {
      node {
        ... on QuizPerformanceType {
          id
          attemptId
          isArchived
          entityId
          enrolmentInfo {
            dueDate
          }
          entity {
            ... on QuizContentType {
              cover {
                url
              }
              duration
              id
              type
              name
              status
            }
          }
        }
        ... on CoursePerformanceType {
          id
          isArchived
          entityId
          enrolmentInfo {
            dueDate
          }
          entity {
            ... on CourseContentType {
              id
              name
              type
              status
              cover {
                url
              }
              duration
            }
          }
        }
        ... on ArticlePerformanceType {
          id
          isArchived
          entityId
          enrolmentInfo {
            dueDate
          }
          entity {
            ... on ArticleContentType {
              id
              name
              type
              status
              cover {
                url
              }
              duration
            }
          }
        }
        ... on PathPerformanceType {
          id
          isArchived
          entityId
          enrolmentInfo {
            dueDate
          }
          entity {
            ... on PathContentType {
              id
              name
              type
              status
              cover {
                url
              }
              duration
            }
          }
        }
        ... on ScormPerformanceType {
          id
          isArchived
          entityId
          enrolmentInfo {
            dueDate
          }
          entity {
            ... on ScormContentType {
              id
              name
              type
              status
              cover {
                url
              }
              duration
            }
          }
        }
        ... on ExternalContentPerformanceType {
          id
          isArchived
          entityId
          enrolmentInfo {
            dueDate
          }
          entity {
            ... on ExternalContentType {
              id
              name
              type
              status
              cover {
                url
              }
              duration
            }
          }
        }
        ... on SurveyPerformanceType {
          id
          isArchived
          entityId
          enrolmentInfo {
            dueDate
          }
          entity {
            ... on SurveyContentType {
              id
              name
              type
              status
              cover {
                url
              }
              duration
            }
          }
        }
        ... on TaskPerformanceType {
          id
          isArchived
          entityId
          enrolmentInfo {
            dueDate
          }
          entity {
            ... on TaskContentType {
              id
              name
              type
              status
              cover {
                url
              }
              duration
            }
          }
        }
        ... on ExercisePerformanceType {
          id
          isArchived
          entityId
          enrolmentInfo {
            dueDate
          }
          entity {
            ... on ExerciseType {
              id
              name
              type
              status
              cover {
                url
              }
              duration
            }
          }
        }
        ... on EventPerformanceType {
          id
          isArchived
          entityId
          enrolmentInfo {
            dueDate
          }
          entity {
            ... on LiveEventContentType {
              id
              name
              type
              status
              cover {
                url
              }
              duration
            }
          }
        }
        ... on EventPerformanceType {
          id
          isArchived
          entityId
          enrolmentInfo {
            dueDate
          }
          entity {
            ... on OfflineEventContentType {
              id
              name
              type
              status
              cover {
                url
              }
              duration
            }
          }
        }
        ... on EventPerformanceType {
          id
          isArchived
          entityId
          enrolmentInfo {
            dueDate
          }
          entity {
            ... on ExternalEventContentType {
              id
              name
              type
              status
              cover {
                url
              }
              duration
            }
          }
        }
        ... on EventPerformanceType {
          id
          isArchived
          entityId
          enrolmentInfo {
            dueDate
          }
          entity {
            ... on RecurringLiveEventContentType {
              id
              name
              type
              status
              cover {
                url
              }
              duration
            }
          }
        }
        ... on EventPerformanceType {
          id
          isArchived
          entityId
          enrolmentInfo {
            dueDate
          }
          entity {
            ... on RecurringOfflineEventContentType {
              id
              name
              type
              status
              cover {
                url
              }
              duration
            }
          }
        }
        ... on EventPerformanceType {
          id
          isArchived
          entityId
          enrolmentInfo {
            dueDate
          }
          entity {
            ... on RecurringExternalEventContentType {
              id
              name
              type
              status
              cover {
                url
              }
              duration
            }
          }
        }
        __typename
      }
    }
  }
}
    `;

export function useContentsByDueDateQuery(options?: Omit<Urql.UseQueryArgs<ContentsByDueDateQueryVariables>, 'query'>) {
  return Urql.useQuery<ContentsByDueDateQuery, ContentsByDueDateQueryVariables>({ query: ContentsByDueDateDocument, ...options });
};